import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';

import FormFieldsCompact from '../../components/form/fieldsCompact';
import Input from '../../components/form/input';
import Versions from '../../components/versions';

import FrontpageQuickButtonsEditor from '../../components/customer/frontpageQuickButtonsEditor';

@withText(props => ({
    name: <Text id='input.name-help'>name</Text>,
    description: <Text id='input.description-help'>description</Text>,
}))
@observer
class NewCustomer extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('customer'),
        };
    }

    createCustomer = async () => {
        const { callback = () => {} } = this.props;
        const { customerStore } = this.props.stores;
        const { newCustomer } = customerStore;
        const response = await customerStore.adminCreate(newCustomer);
        if (response.status === 201) {
            callback();
        }
    }

    componentDidMount() {
        const { idx, id, isNew } = this.props;
        const { customerStore } = this.props.stores;
        if (isNew) {
            // Reset newCustomer to empty object for a blank form
            customerStore.updateKeyValue('newCustomer', {});
        } else {
            // customerStore.adminSetFromIdx(idx);
            customerStore.adminSetFromId(id);
        }
    }

    render() {
        const { week, isNew, drawerLevel } = this.props;
        const { sections } = this.state;
        const { userStore, customerStore } = this.props.stores;
        const { user, isAdmin } = userStore;
        const { newCustomer, adminMembers, customer } = customerStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>

                    {customer && customer.id ? (
                        <Versions stores={this.props.stores} type='customer' id={customer.id} key={`admin-customer-${customer.id}`} />
                    ) : null}

                    {/* <div class='w-100 d-flex flex-column justify-content-start'>
                        <xmp>{JSON.stringify(user.settings, null, 2)}</xmp>
                    </div> */}
                    {/* <xmp>{JSON.stringify(newCustomer, null, 4)}</xmp> */}
                    <h5 class='ms-3 mb-3'>
                        {isNew ? <Text id='customer.new'>New customer</Text> : <Text id='customer.edit'>Edit customer</Text>}
                    </h5>
                    <div class='bg-light d-flex flex-column justify-content-start pt-3'>
                        <FormFieldsCompact stores={this.props.stores} sections={sections} holdingStore={customerStore} objectName={isNew ? 'newCustomer' : 'customer'} isNew={isNew} drawerLevel={drawerLevel} isAdmin={true} defaultShowOnlyRecommended={true} />
                    </div>

                    {!isNew && customer && customer.id ? (
                        <div class='bg-light d-flex flex-column justify-content-start mt-3'>
                            <FrontpageQuickButtonsEditor
                                stores={this.props.stores}
                                customerStore={customerStore}
                                customer={customer}
                                objectName='customer'
                            />
                        </div>
                    ) : null}

                    {isNew && <div class='w-100 d-flex flex-column justify-content-start mt-3 px-4 py-3 bg-light fixed-bottom' style={`bottom: 0; left: 0;`}>
                        <button type='button' class='btn btn-primary rounded-pill' onClick={this.createCustomer}>
                            {isNew ? <Text id='customer.create'>Create customer</Text> : <Text id='customer.save'>Save customer</Text>}
                        </button>
                    </div>}
                </div>
            </div>
        </>);
    }
}

export default NewCustomer;
